<template>
  <v-window class="mb-4">
    <v-img src="/image/legal/terms-of-use.jpg" id="landing-section">
      <v-layout row style="height: 100%">
        <v-layout align-center justify-center>
          <v-flex xs12>
            <v-card color="transparent" flat>
              <v-card-text>
                <h3 id="slogan" class="text-xs-center white--text text-shadow">
                  POLÍTICA DE PRIVACIDAD DEL SERVICIO WSP
                </h3>
                <h4
                  id="subslogan"
                  class="text-xs-center white--text text-shadow mt-3"
                >
                  Martes 15 de diciembre de 2020, Barcelona.
                </h4>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-img>

    <template>
      <div v-waypoint="{ active: true, callback: onWaypoint }"></div>
    </template>

    <v-container>
      <p>Hola, ¿cómo estás?</p>
      <p>
        Ante todo, muchas gracias por usar el servicio wesmartPark (WSP), todo
        el equipo que hay detrás vamos a trabajar duro para que te sea útil y te
        ayude.
      </p>
      <p>
        Este documento contiene los términos y condiciones de uso de WSP, y
        tiene carácter contractual, o sea que define tus derechos y obligaciones
        como cliente de WSP.
      </p>
      <p>
        Acostumbran a ser documentos tediosos y complejos, como en WSP nos
        gustan las cosas sencillas lo vamos a redactar de modo sencillo, y te
        recomendamos leerlo completo, caso que tengas alguna pregunta, no dudes
        en contactarnos.
      </p>
      <p class="mb-0 mt-3">
        Los motivos de actualizar los Términos y condiciones de uso son:
      </p>
      <ol>
        <li>
          Nueva Tecnología de acceso Bluetooth que modifica el proceso de
          registro y de uso de las instalaciones de aparcamiento WSP, este es el
          motivo principal.
        </li>
        <li>
          Aprovechando el motivo principal, redactar de forma más clara y
          completa el resto de las condiciones, sin que ello signifique cambio
          alguno con las anteriores.
        </li>
      </ol>
      <p class="mb-0 mt-3">El presente documento tiene 2 partes:</p>
      <ol>
        <li>
          Terminología: resumen y definición de palabras específicas del
          servicio WSP.
        </li>
        <li>Términos y condiciones de uso del servicio WSP.</li>
      </ol>
      <br />
      <p>Bienvenid@ y recibe un fuerte abrazo del equipo WSP!</p>
      <h1 class="mt-5 primary--text">POLÍTICA DE PRIVACIDAD</h1>
      <p>
        wesmartPark, en adelante WSP, es el nombre comercial del servicio de
        parksharing (aparcamiento compartido) ofrecido por la empresa Nous
        Pàrquings Urbans, S.L.
      </p>
      <p>
        NOUS PARQUINGS URBANS SL, en adelante NPU, con CIF B-65798548 y
        domicilio social en Gran Vía de les Corts Catalanes, 917 08018
        BARCELONA, como propietaria y responsable del tratamiento de los datos,
        gestiona y tramita nuestros sitios web para usuarios (wesmartpark.com),
        y las aplicaciones vinculadas para iOS y Android (conjuntamente,
        “nuestra plataforma”).
      </p>
      <p>
        Al acceder a nuestro sitio web o aplicación y usar nuestros servicios,
        acepta usted que ha leído y que entiende la presente Política de
        privacidad, así como las prácticas para la recopilación y gestión de la
        información que en ella se describen.
      </p>
      <p>
        En WSP se respetan y cuidan los datos personales de los usuarios. Como
        usuario debes saber que tus derechos están garantizados.
      </p>
      <p class="mb-0 mt-3">
        Nos hemos esforzado en crear un espacio seguro y confiable y por eso
        queremos compartir nuestros principios respecto a tu privacidad:
      </p>
      <ul>
        <li>
          Nunca solicitamos información personal a menos que realmente sea
          necesaria para prestarte los servicios que nos requieras.
        </li>
        <li>
          Nunca compartimos información personal de nuestros usuarios con nadie,
          excepto para cumplir con la ley o en caso de que contemos con tu
          autorización expresa.
        </li>
        <li>
          Nunca utilizaremos tus datos personales con una finalidad diferente a
          la expresada en esta política de privacidad.
        </li>
      </ul>
      <p class="mt-3">
        WSP ha adecuado sus plataformas a las exigencias de la Ley Orgánica
        15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal
        (LOPD), y al Real Decreto 1720/2007, de 21 de diciembre, conocido como
        el Reglamento de desarrollo de la LOPD.
      </p>
      <p>
        Cumple también con el Reglamento (UE) 2016/679 del Parlamento Europeo y
        del Consejo de 27 de abril de 2016 relativo a la protección de las
        personas físicas (RGPD), así como con la Ley 34/2002, de 11 de julio, de
        Servicios de la Sociedad de la Información y Comercio Electrónico
        (LSSICE o LSSI).
      </p>
      <p class="mb-0 mt-3">
        Responsable del tratamiento de tus datos personales
      </p>
      <ul>
        <li>Identidad del Responsable: NOUS PARQUINS URBANS, SL</li>
        <li>Nombre comercial: WSP</li>
        <li>NIF/CIF: B65798548</li>
        <li>Dirección: Gran Vía de les Corts Catalanes, 917 08018 BARCELONA</li>
        <li>
          Correo electrónico:
          <a href="mailto:dpo@wesmartpark.com">dpo@wesmartpark.com</a>
        </li>
      </ul>
      <p class="mt-3">
        Esta Política de privacidad fue actualizada por última vez el 1 de
        noviembre de 2020, con motivo de la introducción del sistema bluetooth
        para que los usuarios puedan acceder a los estacionamientos de la red,
        en sustitución de la pegatina TAG pasivo RFID.
      </p>
      <p>
        Podríamos modificar esta Política de privacidad en cualquier momento y
        le invitamos a que la revise regularmente para mantenerse al corriente
        de cualquier modificación, aunque trataremos de comunicarle siempre
        cualquier modificación sustancial de la misma que pueda afectar a sus
        datos personales.
      </p>
      <h2 class="mt-5 primary--text">Ámbito</h2>
      <p>
        La presente Política de privacidad describe detalladamente nuestra
        política y nuestras prácticas en relación con la recopilación, el uso y
        la divulgación de sus datos personales. Entre los valores con los que
        nos identificamos está la transparencia, por eso deseamos que conozcas
        desde el inicio, que la privacidad de tus datos muy es importante para
        nosotros. En esta declaración de privacidad se explica qué datos
        personales recopilamos de nuestros usuarios y cómo los utilizamos.
      </p>
      <p>
        Te invitamos a leer detenidamente estos términos antes de facilitar tus
        datos personales en nuestra plataforma.
      </p>
      <h2 class="mt-5 primary--text">1. Recopilación de datos personales</h2>
      <p>
        Por “datos personales” se entiende cualquier información sobre una
        persona que permita identificarla, ya sea de forma directa o indirecta,
        como su nombre y apellidos, número de teléfono, direcciones postales y
        de correo electrónico, fecha de nacimiento, contraseña e información de
        pago. No incluyen los datos de los que se ha eliminado la identidad
        (datos anónimos).
      </p>
      <p>
        En el curso de nuestras operaciones comerciales, recopilamos y
        procesamos datos personales de diversas formas. Podemos recopilar los
        datos personales que nos proporcione directamente, pero también mediante
        el registro de su interacción con nuestros servicios, por ejemplo,
        utilizando las cookies de nuestro sitio web. Asimismo, podemos recibir
        información procedente de terceros.
      </p>
      <p>
        Para hacer uso de WSP necesitará facilitarnos cierta información acerca
        de usted, por ejemplo, para reservar una plaza de parking, para recibir
        información de nuevas aperturas, facturas de empresa, tickets, y para
        disfrutar de otras ventajas a las que tiene acceso como usuario
        registrado. Además, puede que necesitemos también cierta información
        para que usted pueda formular preguntas y permitirnos que le
        respondamos.
      </p>
      <p class="mb-0 mt-3">
        La información obligatoria se requiere durante el formulario de registro
        de WSP, de no completarla su solicitud no se podrá procesar.
      </p>
      <ul>
        <li>
          <b>Información que nos facilita:</b> Recopilamos y almacenamos
          información que nos facilita a través de nuestra plataforma o que nos
          envía por otras vías.
        </li>
        <li>
          <b>Información acerca de terceros:</b> Si invita a terceros a usar WSP
          como padrino, deberá facilitar únicamente el correo electrónico de
          dichas personas. Deberá obtener el consentimiento de esas otras
          personas antes de proporcionarnos ese dato y garantizarnos que lo ha
          obtenido legalmente.
        </li>
        <li>
          <b>Información de otras fuentes:</b> También puede que recibamos datos
          personales sobre usted de entidades afiliadas, de nuestros socios
          comerciales y de terceros independientes, que podrían combinarse con
          el resto de la información que recopilemos acerca de usted. Así, si
          accede a nuestro sitio web a través de un enlace que pertenece a un
          sitio de alguno de nuestros socios comerciales y se ha registrado
          usted con dicho socio, este podrá compartir con nosotros la
          información que usted le haya facilitado, como sus datos de contacto y
          su perfil. Le ponemos otro ejemplo: si usted accede a servicios de
          terceros (como los servicios de formularios o encuestas) a través de
          nuestro sitio web o uno de nuestros emails, es posible que recopilemos
          cierta información, como su nombre y apellidos, su dirección de correo
          electrónico y cualquier otra información que estos servicios pongan a
          nuestra disposición. En el caso de empresas clientes de WSP también
          pueden dar datos personales suyos como empleados de la misma para
          poder registrarles en nuestra plataforma. Los bancos con los que
          trabajamos nos proporcionan también un token bancario para que usted
          pueda guardar su tarjeta (nosotros no tenemos acceso a ella) y pueda
          así realizar compras sucesivas fácilmente. Colaboramos con nuestros
          socios actuales y con posibles socios futuros para mejorar y
          personalizar su experiencia en nuestro sitio web de acuerdo con las
          prácticas que se describen en la presente Política de privacidad.
        </li>
        <li>
          <b>Recopilación automática de información:</b> De manera automática,
          recopilamos determinada información de su ordenador o dispositivo
          móvil cuando visita nuestro sitio web. Por ejemplo, recopilamos los
          datos de su sesión, incluidos su dirección IP, el software de
          navegación utilizado y el sitio web de referencia. También es posible
          que recopilemos información acerca de su actividad en línea, como el
          contenido que ha visualizado, las páginas que ha visitado y las
          búsquedas que ha realizado. Recopilamos este tipo de información de
          forma automática para tratar de conocer mejor sus intereses y
          preferencias y para personalizar mejor su experiencia.
        </li>
        <li>
          <b
            >Geolocalización y otra información obtenida de sus dispositivos
            móviles:</b
          >
          En el momento en el que utilice la aplicación de WSP en su dispositivo
          móvil, podremos recopilar y usar su información, normalmente del mismo
          modo y con las mismas finalidades que cuando usa nuestro sitio web.
          Además, puede que recopilemos información sobre su ubicación con su
          consentimiento si su dispositivo móvil está configurado para enviar
          esta clase de información a la aplicación de WSP (consulte los ajustes
          de privacidad de su dispositivo móvil). Por ejemplo, podemos usar esta
          información para proporcionarle información sobre los parkings de
          nuestra red que estén cerca de usted. Puede modificar los ajustes de
          privacidad de su dispositivo móvil en cualquier momento y desactivar
          la función que comparte su información de geolocalización con la
          aplicación de WSP. No obstante, si desactiva la opción de compartir la
          información de geolocalización, puede que se vean afectadas algunas de
          las funciones de la aplicación. Para obtener ayuda con los ajustes de
          privacidad de su dispositivo móvil, póngase en contacto con el
          fabricante.
        </li>
      </ul>
      <h2 class="mt-5 primary--text">
        2. Cómo utilizamos sus datos personales
      </h2>
      <p>
        Utilizamos los datos personales que recopilamos sobre usted solo para
        fines específicos. Entre dichos fines, se incluyen ofrecerle nuestros
        servicios; crear y gestionar su registro y su cuenta (lo que incluye el
        acceso a nuestra plataforma y el uso que hace de ella); desarrollar y
        gestionar nuestras actividades comerciales, operaciones promocionales,
        programas de incentivos u operaciones de marketing (incluidas las
        campañas de envío de correos electrónicos, el targeting, el retargeting,
        el perfilado de usuarios y la segmentación).
      </p>
      <p>
        Tal y como se ha indicado más arriba, el procesamiento que hacemos de
        sus datos personales también puede incluir actividades de perfilado de
        usuarios (es decir, cualquier medio automatizado de procesamiento de los
        datos de una persona natural consistente en el uso de dichos datos para
        evaluar determinados aspectos personales, en concreto, para analizar o
        predecir determinados aspectos relativos a las preferencias, los
        intereses, el comportamiento, la ubicación o los movimientos de dicha
        persona) encaminadas a definir los tipos de clientes que utilizan
        nuestros productos y servicios, a mantener nuestro sitio web actualizado
        y pertinente (optimización de la experiencia del cliente), a desarrollar
        nuestro negocio y a elaborar nuestra estrategia comercial.
      </p>
      <p>
        Si desea más información sobre nuestras actividades de procesamiento de
        sus datos personales, consulte la siguiente tabla:
      </p>
      <v-data-table
        dense
        :headers="headers"
        :items="items"
        hide-actions
        class="pb-4"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              class="text-xs-left"
              width="33%"
              style="color: rgba(0, 0, 0, 0.87)"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr>
            <td style="vertical-align: top" class="pb-2 pt-2">
              <span v-html="props.item.objective"></span>
            </td>
            <td style="vertical-align: top" class="pb-2 pt-2">
              <span v-html="props.item.personal"></span>
            </td>
            <td style="vertical-align: top" class="pb-2 pt-2">
              <span v-html="props.item.legal"></span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <h3>Desactivación de su cuenta en WSP</h3>
      <p class="mb-0">
        Podremos emplear información recopilada acerca de usted para tomar la
        decisión de desactivar su cuenta. Concretamente, en los casos
        siguientes:
      </p>
      <ul>
        <li>
          Si, en repetidas ocasiones, no utiliza el servicio de WSP después de
          haber efectuado una reserva.
        </li>
        <li>
          Si el uso que hace de nuestro sitio web y/o servicios contraviene
          nuestras Condiciones de uso.
        </li>
        <li>
          Si se confirma un mal uso del servicio, por ejemplo, estacionar
          ocupando dos plazas, por su parte en nuestra red de parkings.
        </li>
      </ul>
      <p class="mt-3">
        Se le notificará la desactivación de su cuenta por correo electrónico.
      </p>
      <p>
        La desactivación de su cuenta supondrá la pérdida del saldo restante en
        su cuenta WSP, que no procederá a devolución en ningún caso.
      </p>
      <h3>Marketing</h3>
      <p>
        Queremos que le resulte fácil aprovechar nuestros servicios y/u ofertas
        especiales. Para ello, es posible que reciba correos electrónicos o
        notificaciones automáticas de la aplicación con información acerca de
        ofertas y servicios que podrían resultar de su interés.
      </p>
      <p>
        Recibirá nuestros mensajes comerciales si usted da su consentimiento
        explícito o se registra en nuestro servicio y (en este último caso, solo
        le remitiremos mensajes relacionados con WSP), y siempre que no haya
        cancelado su suscripción a dichos mensajes.
      </p>
      <p>
        Cada vez que recibe un correo electrónico de este tipo, podrá indicarnos
        si ya no desea recibirlos más, rechazar las notificaciones automáticas
        de la aplicación o modificar los ajustes de su dispositivo móvil para
        este último fin. Podrá darse de baja de las comunicaciones comerciales
        en cualquier momento haciendo clic en el enlace de cancelar suscripción
        que se encuentra en la parte inferior de todas las comunicaciones que le
        enviaremos.
      </p>
      <p>
        Tenga en cuenta que puede que sigamos enviándole comunicaciones de
        servicios, como mensajes administrativos acerca de su cuenta o mensajes
        transaccionales relativos a alguna de sus reservas hasta que cierre su
        cuenta.
      </p>
      <h2 class="mt-5 primary--text">
        3. Con quién compartimos su información
      </h2>
      <p>
        Podremos compartir sus datos personales con otras entidades, entre las
        que se incluyen otras empresas del grupo y terceros (tales como
        parkings, aplicaciones y proveedores de servicios que operen en nuestro
        nombre), y en un sentido más general, con cualquiera de nuestros socios
        comerciales o proveedores. En el caso de que vendiéramos o liquidáramos
        nuestro negocio (ya fuera de forma total o parcial) y dicha venta o
        liquidación implicara sus datos personales, o en el caso de que nos
        fusionáramos con otra empresa, compartiríamos sus datos personales con
        el nuevo propietario del negocio o con el socio de la fusión, según el
        caso. Si nos vemos en la obligación legal de hacerlo, compartiremos sus
        datos personales para proteger a nuestros clientes y nuestro sitio web,
        así como nuestra empresa, nuestros derechos y nuestra propiedad.
      </p>
      <p>
        Exigimos a todos los terceros que respeten la seguridad de los datos
        personales y que los traten con arreglo a la ley. Nuestros proveedores
        de servicios externos no tienen nuestra autorización utilizar los datos
        personales para sus propios fines, y solo les permitimos procesarlos
        para fines específicos y según nuestras instrucciones.
      </p>
      <p class="mb-0 mt-3">
        <b
          >A continuación, le ofrecemos más información sobre las entidades que
          podrían acceder a sus datos personales:</b
        >
      </p>
      <ul>
        <li>
          <b>ParkingManagers:</b> Nuestra plataforma de gestión de aparcamientos
          a la que enviamos el ID de reserva, matrícula y fechas de entrada y
          salida del parking, así como las acciones que se den en cada
          aparcamiento como los accesos al mismo. Esta información sólo está
          disponible para los gestores de los aparcamientos, para tener un
          control de lo que ocurre en el parking en cada momento. No se envían
          más datos identificativos.
        </li>
        <li>
          <b
            >Proveedores de servicios externos que nos prestan sus servicios o
            actúan en nuestro nombre, en concreto, para:</b
          >
          realizar análisis comerciales; procesar datos o pagos; prestar
          servicios de atención al cliente, de marketing o de relaciones
          públicas; divulgar encuestas o sorteos de premios; o con fines de
          prevención de fraudes. Tenga en cuenta que es la plataforma bancaria
          la que procesa la información de pago, ya que ni el parking ni
          nosotros tenemos acceso a ella. Nosotros sólo guardamos un token
          bancario, para que usted pueda guardar su tarjeta en la plataforma y
          comprar recurrentemente sin tener que introducir la numeración de su
          tarjeta reiteradamente. Esta información de pago está encriptada y es
          segura. Además, es posible que también les autoricemos para recopilar
          información en nuestro nombre, lo que incluye, por ejemplo, la que sea
          necesaria para utilizar las características de nuestro sitio web o
          facilitar la distribución de anuncios online personalizados acorde a
          sus intereses como usuario. Los proveedores de servicios externos
          tendrán acceso a la información y podrán recopilarla en la medida que
          tengan que hacerlo para llevar a cabo sus funciones. No podrán
          compartirla ni usarla con ningún otro propósito.
        </li>
        <li>
          <b>Empresas pertenecientes a nuestro grupo:</b> Podremos compartir sus
          datos personales dentro de nuestro grupo. En la medida en que las
          empresas de nuestro grupo tengan acceso a su información, seguirán
          unas prácticas al menos tan restrictivas como las prácticas descritas
          en la presente Política de privacidad. Cumplirán asimismo con las
          leyes aplicables en relación con la transmisión de comunicaciones
          comerciales y, cada vez que reciba un mensaje de este tipo, le
          permitirán al menos optar entre continuar recibiendo dichas
          comunicaciones o no.
        </li>
      </ul>
      <p class="mb-0 mt-3">
        Podremos también compartir su información dentro de nuestro grupo o con
        terceros si creemos, a nuestra entera discreción, que la divulgación de
        dicha información es necesaria en las circunstancias siguientes:
      </p>
      <ul>
        <li>
          Para cumplir con citaciones, órdenes judiciales u otros procesos
          legales legítimos y exigibles; para establecer o ejercer nuestros
          derechos legales; para defendernos de demandas judiciales; o en
          cualquier otro caso en que la ley lo exija. En tales casos, nos
          reservamos el derecho de presentar o retirar cualquier objeción o
          derecho legales de los que dispongamos.
        </li>
        <li>
          Si nos vemos legalmente obligados a hacerlo, compartiremos los datos
          que recopilemos con las fuerzas del orden y otros organismos
          gubernamentales.  Para investigar, prevenir o tomar medidas con
          respecto a las actividades ilegales o presuntamente ilegales; para
          proteger y defender nuestros derechos, nuestra propiedad, nuestra
          seguridad, a nuestros usuarios o a otras personas; y conforme a lo
          establecido <b>Condiciones de uso</b> u otros acuerdos, incluso con
          nuestros socios o proveedores.
        </li>
        <li>
          En relación con una transacción corporativa, como una liquidación,
          fusión, adquisición, consolidación o venta de activos, o en el caso
          poco probable de quiebra.
        </li>
      </ul>
      <p class="mt-3">
        Fuera del ámbito de las disposiciones anteriores, y cuando ello sea
        necesario en virtud de la normativa legal que resulte de aplicación, se
        le informará cuando sus datos personales se vayan a compartir con
        terceros, y podrá solicitarnos que no los compartamos si así lo desea.
      </p>
      <p>
        También es posible que compartamos información anónima o agregada con
        terceros, incluidos los anunciantes y los inversores. Por ejemplo,
        podremos comunicar a nuestros anunciantes el número de visitantes de
        nuestro sitio web o los parkings más utilizados. Esta información no
        contiene ningún dato personal.
      </p>
      <h2 class="mt-5 primary--text">
        4. Durante cuánto tiempo guardamos su información
      </h2>
      <p>
        Podremos almacenar parte de la información vinculada a su cuenta en
        nuestros registros, principalmente para fines de análisis o para el
        mantenimiento de dichos registros. El periodo de conservación de sus
        datos personales depende de la finalidad para la cual los recopilemos y
        del uso que de ellos hagamos.
      </p>
      <p>
        Solo conservaremos su información de carácter personal el tiempo que
        resulte necesario para los fines establecidos en el apartado 2 “Cómo
        utilizamos sus datos personales” o para cumplir con nuestras
        obligaciones legales. Para los fines comerciales, el periodo de
        conservación será de 5 años a partir de la fecha de su última actividad.
        Es posible que guardemos determinada información personal durante un
        periodo más prolongado, incluso después de que haya cerrado su cuenta,
        si dicha información es necesaria para cumplir con nuestras obligaciones
        legales, para mantener la seguridad, para prevenir fraudes y abusos, y
        para defender o ejercer nuestros derechos.
      </p>
      <h2 class="mt-5 primary--text">5. Cookies y otras tecnologías web</h2>
      <p>
        Recopilamos información a través del uso de cookies y otras tecnologías
        similares (píxeles invisibles). Las cookies son pequeños archivos de
        texto que se guardan automáticamente en su ordenador o dispositivo móvil
        cuando visita un sitio. Las cookies y los píxeles invisibles se
        almacenan en su navegador de internet. Las cookies contienen información
        básica acerca de su uso de internet. Su navegador reenvía esas cookies a
        nuestro sitio web cada vez que lo visita para que este reconozca su
        ordenador o dispositivo móvil con el fin de personalizar y mejorar su
        experiencia de navegación.
      </p>
      <p>
        Podrá obtener más detalles sobre las cookies y las tecnologías similares
        que utilizamos (como los píxeles invisibles) en nuestra Política de
        cookies.
      </p>
      <p>
        También podrá encontrar más información sobre las cookies en general,
        incluso sobre cómo ver qué cookies se instalan en su dispositivo (móvil)
        y cómo gestionarlas y eliminarlas en
        <a href="http://www.allaboutcookies.org/es/" target="_blank"
          >http://www.allaboutcookies.org/es/</a
        >
        y
        <a href="http://www.allaboutcookies.org/es/" target="_blank"
          >http://www.youronlinechoices.com/es/</a
        >.
      </p>
      <p class="mb-0 mt-3">
        Utilizamos cookies en nuestro sitio web con las siguientes finalidades
        generales:
      </p>
      <ul>
        <li>
          Identificar su navegador cuando regresa a nuestro sitio web, para
          guardar y recordar las preferencias que haya definido durante su
          visita anterior. Por ejemplo, si se ha registrado en nuestro sitio
          web, las cookies pueden permitirnos conservar sus datos de inicio de
          sesión para que no tenga que volver a introducirlos cada vez que
          regrese.
        </li>
        <li>
          Personalizar su experiencia de navegación y el contenido de nuestro
          sitio web. Por ejemplo, cuando usted visita una página de internet,
          nosotros, nuestros proveedores de servicios o nuestros socios
          instalamos de forma automática una cookie para reconocer su navegador
          cuando acceda a internet, y le mostramos así la información basada en
          lo que parece que le interesa.
        </li>
        <li>
          Para medir y documentar la eficacia de las diferentes funciones,
          ofertas y comunicaciones electrónicas (determinando qué correos
          electrónicos ha abierto y si ha pinchado en un enlace del correo
          electrónico).
        </li>
      </ul>
      <p class="mt-3">
        La sección de configuración de la barra de herramientas de la mayoría de
        los navegadores debería ofrecerle información sobre cómo evitar que su
        navegador acepte cookies nuevas, cómo hacer que su navegador le
        notifique la recepción de una cookie nueva o cómo deshabilitar todas las
        cookies que no le resulten útiles. Tenga en cuenta que si se niega a
        aceptar cookies, es posible que no pueda acceder a muchas de las
        herramientas , del contenido o de las funciones que se ofrecen en
        nuestro sitio web.
      </p>
      <h3>Balizas web</h3>
      <p>
        Nuestro sitio web puede que utilice también balizas web (también
        llamadas “GIF invisibles” o “píxeles invisibles”), que son pequeñas
        imágenes digitales con un identificador único que funcionan como cookies
        y que se instalan en el código de una página web. Las empleamos para
        conocer los patrones de búsqueda de los usuarios que acceden a una
        página desde otra dentro de nuestro sitio web, así como para
        proporcionar o transmitir información a las cookies, pero también para
        saber si accede a nuestro sitio web desde un anuncio online mostrado en
        el sitio de un tercero y, por último, para mejorar el rendimiento de
        nuestro sitio web. También podemos permitir a nuestros proveedores de
        servicios que utilicen las balizas web para ayudarnos a saber qué
        correos electrónicos han abierto los destinatarios y para realizar un
        seguimiento del tráfico de visitantes y de las acciones realizadas en
        nuestro sitio web. Hacemos esto para medir mejor la pertinencia de
        nuestro contenido y la eficacia de nuestras ofertas.
      </p>
      <h3>
        Datos recopilados por socios comerciales y redes publicitarias para
        divulgar anuncios personalizados
      </h3>
      <p>
        Permitimos a terceros recopilar información acerca de las actividades
        que usted lleva a cabo online por medio de cookies y otras tecnologías.
        Estos terceros incluyen agencias de publicidad que recopilan información
        acerca de sus intereses cuando visualiza o interactúa con alguno de sus
        anuncios publicitarios en diversas páginas web u otras aplicaciones.
        Esta información recopilada por terceros se utiliza después para
        predecir su comportamiento o sus preferencias y para mostrar anuncios
        personalizados en sitios de terceros. Tenga en cuenta que no tenemos
        ningún control ni acceso a las cookies y demás tecnologías que los
        terceros puedan emplear para recopilar información sobre sus intereses,
        y sus prácticas quedan fuera del alcance de la presente Política de
        privacidad. Algunas de estas empresas son miembros de la Network
        Advertising Initiative, que ofrece una única ubicación para dejar de
        recibir anuncios personalizados procedentes de las empresas que la
        integran. Si desea más información,
        <a href="https://thenai.org/" target="_blank">haga clic aquí</a>.
      </p>
      <h3>Señales DNT (Do Not Track)</h3>
      <p>
        Su navegador de internet puede enviar una señal “DNT” (“Do Not Track”)
        para informar a WSP y otros sitios web de que usted no desea ser
        rastreado. Debido a las diferencias entre las configuraciones
        predeterminadas de los navegadores de internet y el modo en el que
        incorporan las señales DNT, los operadores de sitios no siempre tienen
        claro si los usuarios han seleccionado el parámetro DNT o si saben
        siquiera que pueden configurarlo. Tenga en cuenta que, por el momento,
        WSP no puede tener en cuenta las señales DNT.
      </p>
      <h2 class="mt-5 primary--text">6. Sus derechos</h2>
      <p>
        Puede consultar, complementar y actualizar la información que nos haya
        facilitado accediendo a las secciones “Mi cuenta” y “Mis pegatinas” en
        la plataforma. También podrá cerrar su cuenta en WSP en dicha sección o
        escribiéndonos a
        <a href="mailto:info@wesmartpark.com">info@wesmartpark.com</a>. Si
        decide cerrar su cuenta en WSP, la desactivaremos y guardaremos la
        información necesaria para garantizar la integridad de la base de datos
        y los reportes de WSP. Recuerde que en cuanto haya cerrado su cuenta, ya
        no podrá acceder a la plataforma, ni a su información personal, ni
        revisar información relativa a su historial de reservas.
      </p>
      <p>
        De conformidad con las leyes y normativas aplicables, tendrá derecho de
        acceso, rectificación y borrado de sus datos personales, el derecho a
        restringir el acceso a dichos datos, el derecho a la portabilidad de sus
        datos y el derecho a oponerse al procesamiento de sus datos personales.
        A continuación, encontrará más información y detalles sobre cómo y
        cuándo puede ejercer sus derechos. Responderemos a su solicitud en un
        plazo de un mes, pero nos reservamos el derecho a ampliar este periodo
        hasta dos meses si fuera preciso, en función de la complejidad y el
        número de solicitudes.
      </p>
      <h3>
        Para obtener más información relativa a sus derechos, siga leyendo:
      </h3>
      <p class="mb-0">
        Tendrá los siguientes derechos en lo referente a sus datos personales:
      </p>
      <ul>
        <li>
          El derecho a acceder a sus datos personales. En virtud de este
          derecho, podrá solicitar que le enviemos una copia de los datos
          personales que almacenamos sobre su persona y verificar que los
          estamos procesando de forma legal.
        </li>
        <li>
          El derecho a solicitar que corrijamos sus datos si son inexactos.
          También podrá complementar cualquier dato incompleto que tengamos,
          teniendo en cuenta los fines del procesamiento.
        </li>
        <li>
          El derecho a solicitar la eliminación de sus datos personales si:
          <ul>
            <li>
              sus datos personales dejan de ser necesarios para nuestros
              propósitos de recopilación y procesamiento;
            </li>
            <li>
              retira su consentimiento en el caso de que el procesamiento de sus
              datos personales se base en el consentimiento y sin que haya
              ningún otro fundamento jurídico;
            </li>
            <li>
              se opone al procesamiento de sus datos personales y no disponemos
              de un motivo legítimo que prevalezca y justifique el procesamiento
              por nuestra parte;
            </li>
            <li>sus datos personales se procesan de forma ilegal; o</li>
            <li>
              sus datos personales se deben eliminar por imperativo legal.
            </li>
          </ul>
        </li>
        <li>
          El derecho de oponerse al procesamiento de sus datos personales.
          Cumpliremos su solicitud, a menos que tengamos un imperioso interés
          legítimo que prevalezca o tengamos que seguir procesando sus datos
          personales para establecer, ejercer o defendernos de una demanda
          judicial.
        </li>
        <li>
          El derecho a restringir el procesamiento de sus datos personales si:
          <ul>
            <li>
              cuestiona la exactitud de sus datos personales mientras los
              verificamos;
            </li>
            <li>
              el procesamiento se realiza de forma ilegítima, se opone a que se
              eliminen sus datos personales y solicita que, en lugar de ello, se
              restrinja el procesamiento;
            </li>
            <li>
              ya no necesitamos sus datos personales para los fines de
              procesamiento, pero usted los exige para demandas judiciales; o
            </li>
            <li>
              se opone al procesamiento de sus datos personales, lo cual abrirá
              un periodo durante el cual tendremos que verificar si hay
              fundamentos jurídicos que prevalezcan sobre su oposición.
            </li>
          </ul>
        </li>
        <li>
          El derecho a la portabilidad de sus datos. Puede solicitarnos que le
          enviemos los datos personales que le afecten en un formato
          estructurado e informatizado de uso habitual. También puede
          solicitarnos que enviemos dichos datos personales a un tercero, en los
          casos en los que esto sea factible. Solo detentará este derecho si
          concierne a datos personales que nos haya proporcionado usted, si el
          procesamiento de dichos datos se basa en el consentimiento o es
          necesario para la operatividad de un contrato entre usted y nosotros,
          y si el procesamiento se realiza por medios automatizados.
        </li>
      </ul>
      <p class="mt-3">
        Puede ejercer varios de sus derechos a través de la sección “Mis
        ajustes” de su cuenta. Para ejercer el resto de sus derechos, puede
        formalizar una solicitud por correo electrónico a dpo@wesmartpark.com.
      </p>
      <p>
        No tendrá que abonar ninguna tasa para acceder a sus datos personales
        (ni para ejercer ninguno de sus demás derechos). No obstante, sí es
        posible que le cobremos una tasa razonable si su solicitud es claramente
        infundada, repetitiva o excesiva.
      </p>
      <p>
        Con el fin de facilitarnos la confirmación de su identidad y
        garantizarle el derecho a acceder a sus datos personales (o a ejercer
        cualquier otro de sus derechos), podremos pedirle que nos aporte una
        copia de su documento de identidad u otro documento. Se trata de una
        medida de seguridad encaminada a garantizar que los datos personales no
        se revelen a nadie que no tenga derecho a recibirlos.
      </p>
      <p>
        También es posible que nos pongamos en contacto con usted para solicitar
        más información concerniente a su solicitud para agilizar nuestra
        respuesta.
      </p>
      <h2 class="mt-5 primary--text">
        7. Cómo protegemos sus datos personales
      </h2>
      <p>
        Queremos que use nuestro sitio web con confianza. Para ello, nos
        comprometemos a proteger la información que recopilamos. Aunque ningún
        sitio puede garantizar seguridad absoluta debido a las dificultades
        inherentes a las actividades online, hemos implementado y mantenemos
        medidas organizativas, técnicas, administrativas y físicas apropiadas
        para proteger los datos personales que nos proporciona contra el acceso
        no autorizado o ilegal, la revelación de información, así como contra
        pérdidas, daños, alteraciones o destrucciones accidentales.
      </p>
      <h2 class="mt-5 primary--text">
        8. Información relativa a menores de edad
      </h2>
      <p>
        Nuestro sitio web está reservado para adultos y no ofrece servicios
        dirigidos a menores. Nunca recopilaremos conscientemente datos relativos
        a menores de edad. En caso de que recibamos datos personales de alguien
        que sepamos que tiene menos 18 años, eliminaremos o destruiremos dicha
        información tan pronto como sea razonablemente posible.
      </p>
      <h2 class="mt-5 primary--text">9. Enlaces externos</h2>
      <p>
        Nuestro sitio web puede incluir enlaces a sitios, complementos y
        aplicaciones de terceros. En caso de que acceda a otros sitios desde
        enlaces proporcionados por nuestro sitio web, los operadores de dichos
        sitios podrán recopilar o compartir información acerca de usted. Esta
        información se usará de conformidad con sus respectivas políticas de
        privacidad, que podrían ser distintas de nuestra Política de privacidad.
        No tenemos ningún control sobre estos sitios web de terceros, por lo que
        le recomendamos que revise las políticas de privacidad publicadas en los
        sitios web de dichos terceros para conocer toda la información relativa
        a sus procedimientos de recopilación, uso y divulgación de los datos
        personales.
      </p>
      <h2 class="mt-5 primary--text">
        10. Cambios en la Política de privacidad
      </h2>
      <p>
        Podremos realizar enmiendas o ajustes a la presente Política de
        privacidad de vez en cuando. Anotaremos la fecha en la que se hicieron
        las últimas revisiones en la primera página de la presente Política de
        privacidad. Las revisiones entrarán en vigor en el momento de su
        publicación en nuestro sitio web. Notificaremos a nuestros usuarios
        todos los cambios importantes que se realicen en la presente Política de
        privacidad mediante el envío de un aviso a la dirección de correo
        electrónico que nos hayan proporcionado o mediante la publicación de un
        aviso en nuestro sitio web. Le recomendamos que consulte la presente
        Política de privacidad periódicamente para examinar la versión más
        actual.
      </p>

      <h2 class="mt-5 primary--text">11. Cómo contactar con nosotros</h2>
      <p>
        Si tiene alguna duda o queja sobre cómo procesamos sus datos personales,
        escríbanos a dpo@wesmartpark.com. Asimismo, tiene el derecho de
        interponer una reclamación al respecto ante la Agencia Española de
        Protección de Datos (es decir, la autoridad del Estado español en
        materia de protección de datos). No obstante, antes de acudir a una
        autoridad supervisora, nos gustaría tener la oportunidad de abordar las
        cuestiones que le preocupen, así que le rogamos que se ponga en contacto
        con nosotros en primer lugar.
      </p>
      <p>
        Si nos contacta por teléfono, las conversaciones podrán ser grabadas.
        Usamos estas grabaciones para mejorar la calidad o la conformidad de
        nuestro servicio de atención al cliente, para comprobar la exactitud de
        la información que nos facilita, para asegurar la prevención de fraudes
        y para formar a nuestros equipos. Conservamos estas grabaciones el
        tiempo que resultan necesarias y, después, las borramos. Los datos
        personales que nos proporcione durante la llamada se tratarán de acuerdo
        con las disposiciones de la presente Política de privacidad.
      </p>
    </v-container>
  </v-window>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

export default {
  name: 'PrivacyPolicyDefault',
  data() {
    return {
      headers: [
        {
          text: 'Objetivo/actividad',
          align: 'start',
          sortable: false,
          value: 'objective',
        },
        { text: 'Datos personales', sortable: false, value: 'personal' },
        { text: 'Fundamento jurídico', sortable: false, value: 'legal' },
      ],
      items: [
        {
          objective:
            'Gestionar su registro y su cuenta, lo que incluye permitirle acceder a nuestro sitio web y utilizarlo.',
          personal:
            'Nombre<br/>Dirección postal<br/>Dirección de correo electrónico<br/>Teléfono móvil<br/>Contraseña<br/>Datos del navegador o del dispositivo',
          legal: 'Necesidad de formalizar un contrato con usted.',
        },
        {
          objective: 'Realizar y gestionar reservas en parkings.',
          personal:
            'Nombre<br/>Dirección postal<br/>Dirección de correo electrónico<br/>Teléfono móvil<br/>Dirección IP<br/>Datos del navegador o del dispositivo<br/>Matrícula<br/>Datos de geolocalización<br/>Bluetooth',
          legal: 'Necesidad de usar la red de parkings.',
        },
        {
          objective:
            'Comunicarnos con usted en general y, en concreto, con respecto a:<ul><li>nuestro sitio web;</li><li>sus preguntas y comentarios;</li><li>avisarle de cambios en nuestras condiciones o en nuestra política de privacidad;</li><li>pedirle que deje una opinión o realice una encuesta;</li><li>la administración de nuestro sitio web y el diagnóstico de problemas.</li></ul>',
          personal:
            'Nombre<br/>Dirección postal<br/>Dirección de correo electrónico<br/>Teléfono móvil<br/>Contraseña<br/>Datos del navegador o del dispositivo',
          legal:
            'Nuestros intereses legítimos (mantener nuestros registros actualizados y estudiar cómo utilizan los clientes nuestros productos/servicios, responder a sus preguntas y comentarios, llevar nuestro negocio de forma eficiente, prestar servicios informáticos, garantizar la seguridad de la red y prevenir fraudes)..',
        },
        {
          objective:
            'Medir el interés en nuestros productos, servicios y el sitio web, y mejorarlos, así como personalizar su experiencia de usuario.',
          personal:
            'Nombre<br/>Dirección de correo electrónico<br/>Datos de la sesión<br/>Actividad online en nuestro sitio web<br/>Datos del navegador o del dispositivo<br/>Datos de geolocalización',
          legal:
            'Nuestros intereses legítimos (definir los tipos de clientes que utilizan nuestros productos y servicios, mantener nuestro sitio web actualizado y pertinente, desarrollar nuestro negocio y elaborar nuestra estrategia comercial).',
        },
        {
          objective:
            'Informarle de promociones y ofertas especiales, así como de los servicios que ofrecemos y que pueden resultar de su interés.',
          personal:
            'Nombre<br/>Dirección de correo electrónico<br/>Datos de la sesión<br/>Actividad online en nuestro sitio web<br/>Nombre de usuario<br/>Datos de geolocalización<br/>Teléfono móvil<br/>Datos del navegador o del dispositivo',
          legal:
            'Su consentimiento para recibir comunicaciones comerciales a través de correos electrónicos, notificaciones automáticas de la aplicación o mensajes de texto.',
        },
        {
          objective: 'Organizar sorteos de premios, concursos o encuestas.',
          personal:
            'Nombre<br/>Dirección postal<br/>Dirección de correo electrónico<br/>Contenido proporcionado por usted',
          legal:
            'Necesidad de formalizar un contrato con usted.<br /> Nuestros intereses legítimos (verificar la aptitud, estudiar cómo utilizan los clientes nuestros productos/servicios, desarrollar dichos productos y servicios, y expandir nuestro negocio).',
        },
        {
          objective:
            'Gestionar nuestro proceso de contratación y su candidatura para trabajar en WSP.',
          personal:
            'Nombre<br/>Dirección de correo electrónico<br/>Número de teléfono<br/>Dirección postal<br/>CV',
          legal:
            'Necesidad de emprender acciones a petición del candidato antes de formalizar un contrato de empleo.<br />Nuestros intereses legítimos (administrar nuestro proceso de contratación).',
        },
        {
          objective:
            'Administrar y proteger nuestro negocio, resolver disputas o solucionar problemas y prevenir actividades que podrían estar prohibidas o ser ilegales.',
          personal:
            'Nombre<br/>Dirección postal<br/>Dirección de correo electrónico<br/>Número de teléfono<br/>Nombre de usuario<br/>Datos de la sesión',
          legal:
            'Nuestros intereses legítimos (llevar nuestro negocio y, además, prevenir fraudes y otras actividades prohibidas o ilegales.',
        },
      ],
    };
  },
  methods: {
    onWaypoint({ going, direction, el }) {
      if (going === this.$waypointMap.GOING_IN) {
        EventBus.$emit(keys.eventShowToolbar, { offset: el.offsetTop });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#landing-section {
  height: calc(100vh);
}
#landing-section #slogan {
  font-weight: bold;
}
.xs #landing-section #slogan {
  font-size: 4vh;
  line-height: 6vh;
}
.sm #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.md #landing-section #slogan {
  font-size: 6vh;
  line-height: 6vh;
}
.lg #landing-section #slogan {
  font-size: 7vh;
  line-height: 7vh;
}

.xs #landing-section #subslogan {
  font-size: 2vh;
  line-height: 2vh;
}
.sm #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.md #landing-section #subslogan {
  font-size: 3vh;
  line-height: 3vh;
}
.lg #landing-section #subslogan {
  font-size: 4vh;
  line-height: 4vh;
}

#landing-section #landing-section-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
#landing-section .v-card {
  margin-top: -10%;
}
</style>
